import { ISutochnoPilot } from '../../types/sutochnoPilot';
import { fetchGetSutochnoPilotInfo } from '../../repositories/billing-accounts/v1/get-sutochno-pilot-info';
import { DEFAULT_RESPONSE } from './constants';
import { mappers } from './mappers';
import { IGetSutochnoPilotParams } from './types';
import { checkInternetExplorer, checkSearchBot } from '../../utils/userAgent';

export async function getSutochnoPilot(params: IGetSutochnoPilotParams): Promise<ISutochnoPilot> {
  const { httpApi, logger, timeout, telemetry, userAgent } = params;

  try {
    const response = await fetchGetSutochnoPilotInfo({
      httpApi,
      parameters: {},
      config: {
        ecnhancersConfig: { timeout },
      },
      mappers: mappers({ telemetry, logger }),
    });

    return response as ISutochnoPilot;
  } catch (error) {
    const isIE = checkInternetExplorer(userAgent);
    const isSearchBot = checkSearchBot(userAgent);

    // исключаем ошибки IE и поисковых ботов, чтобы не портить метрики SLO
    if (!isIE && !isSearchBot) {
      logger.error(error, {
        description: 'Запрос get-sutochno-pilot-info на Главной',
        degradation: 'Пилот посуточной будет недоступен для пользователя. Фильтры будут работать по обычному флоу',
      });

      telemetry.increment('get-sutochno-pilot-info.request.exception');
    }
  }

  return DEFAULT_RESPONSE;
}
